import * as React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { createApiClient } from '../../services/ApiClient';
import { isEmpty } from 'lodash';
import { ButtonToolbar, Button, ButtonGroup } from 'react-bootstrap';
import HistoryStatusModal from './history';
import NotifyModal from './notify';

let moment = require('moment');

interface Props {
    listUserForms: Array<any>
    openForm: (valuesId: string, formId: string) => any;
    removePDF: (valuesId: string, formId: string, type?: string) => any;
    onUnckedUpdate: (form: any, valuesId: any) => any;
}


const nextStep = cell => (<span style={{whiteSpace:"pre-line"}}>{cell}</span>)

const formateUpdate = cell => !isEmpty(cell) ? (<span className="label label-success">{cell}</span>) : (<span ></span>)

export default class RequestList extends React.Component<Props> {
    private checkbox: HTMLInputElement;
    private modalHistory: HistoryStatusModal;
    private modalNotify: NotifyModal;

    rowAdditionalRequest = (row) => {
        const {
            status,
            reportOneNeedResend,
            reportTwoNeedResend,
            reportResponseTime
        } = row

        if (reportOneNeedResend || reportTwoNeedResend) {
            return 'tr-orange'
        }

        if (status === 9 ) {
            return 'tr-red'
        }

        const [day, month, year] = reportResponseTime.split('.');

        if( day == undefined || month == undefined || year == undefined) return ' ';

        const reportDate = new Date(year, month - 1, day);
        const timeFromPastReport = (new Date() > reportDate)&&(reportDate.getFullYear() > 2001)

        const future30 = new Date().setDate((new Date()).getDate() + 30);

        const timeFromPastReport30Days = (new Date(future30) > reportDate)&&(reportDate.getFullYear() > 2001)

        if (status === 12 || status === 13 || status == 14 || status === 15 || status === 16 || status === 18)
        {
            if(timeFromPastReport){
                return 'tr-red'
            } 
            if(timeFromPastReport30Days){
                return 'tr-orange'
            }
        }

        return ''
    }

    render() {
        const getTypeByStatus = (status: number): 'one' | 'two' => ({
            12: 'one',
            13: 'one',
            16: 'one',
            14: 'two',
            15: 'two',
            18: 'two',
        }[status])

        const getTypeByResponseReport = ({ responseReportOne, responseReportTwo } : Record<string, boolean>): 'one' | 'two' | undefined => {
            if (responseReportTwo) {
                return 'two'
            }
            if (responseReportOne) {
                return 'one'
            }
            return undefined
        }

        const options = {
            defaultSortName: 'changeTime',
            defaultSortOrder: 'asc',
            noDataText: 'Вы еще не подавали заявок',
            onRowClick: (row) => {
                this.props.openForm(row.valuesId, row.formId);
            }
        }

        const statusFormate = (cell, row) => {
            const { responseTime, reportResponseTime } = row;

            switch (cell) {
                case 0: return (<span className="label label-primary">Черновик</span>)
                case 1: return (<span className="label label-success">Одобрена</span>)
                case 2: return (<span className="label label-default">Отправлено</span>)
                case 3: return (<span className="label label-danger">Отклонена</span>)
                case 4: return (<span className="label label-default">Ожидание PDF</span>)
                case 5: return (<span className="label label-info" style={{whiteSpace:"pre-line"}}>Запрошены документы</span>)
                case 6: return (<span className="label label-success" style={{whiteSpace:"pre-line"}}>На рассмотрении</span>)
                case 7: return (<span className="label label-success" style={{whiteSpace:"pre-line"}}>Документы отправлены</span>)
                case 8: return (<span className="label label-danger">Отозвана</span>)
                case 9: return (<>
                    <span className="label label-warning" title="Дополнительный запрос">Дополнительный запрос</span>
                    <div>ответить до {responseTime}</div>
                </>)
				case 10: return (<>
                    <span className="label label-default">Приостановка</span>
                    <br/>
                    <span className="label label-default">рассмотрения</span>
                </>)
                case 12: return (<>
                    <span className="label label-primary" title="Отчёт №1">Отчёт №1</span>
                    <div>ответить до {reportResponseTime}</div>
                </>)
                case 14: return (<>
                    <span className="label label-primary" title="Отчёт №2">Отчёт №2</span>
                    <div>ответить до {reportResponseTime}</div>
                </>)
                case 13: return (<span className="label label-default">Ожидание PDF Отчёта №1</span>)
                case 15: return (<span className="label label-default">Ожидание PDF Отчёта №2</span>)
                case 16: return (<span className="label label-success">Отчёт №1 принят к сведению</span>)
                case 18: return (<span className="label label-success">Отчёт №2 принят к сведению</span>)
            }
        }

        const actionFormate = (_, row) =>{
            let api = createApiClient();

            const {
                formId,
                valuesId,
                response,
                status,
                responseReportOne,
                responseReportTwo
            } = row

            const handleShowHistory = (e) =>{
                e.stopPropagation();
                this.modalHistory.show(formId, valuesId);
            }

            const handleShowNotify = (e) =>{
                e.stopPropagation();
                this.props.onUnckedUpdate(formId, valuesId);

                this.modalNotify.show(formId, valuesId);
            }

            const handleRemovePDF = (e) => {
                e.stopPropagation();
                this.props.removePDF(formId, valuesId, type)
            }

            const type = getTypeByResponseReport({ responseReportOne, responseReportTwo })

            const content = {
                undefined: 'Удалить PDF',
                one: 'Удалить PDF Отчёта №1',
                two: 'Удалить PDF Отчёта №2'
            }[type]

            return (
                <ButtonToolbar>
                    <ButtonGroup vertical block>
                        <Button onClick={handleShowNotify} bsStyle="success">Уведомление</Button>
                        {(status == 0) && response && (
                            <Button bsStyle="danger" onClick={handleRemovePDF}>{content}</Button>
                        )}
                        {(status == 13) && responseReportOne && (
                            <Button bsStyle="danger" onClick={handleRemovePDF}>{content}</Button>
                        )}
                        {(status == 15) && responseReportTwo && (
                            <Button bsStyle="danger" onClick={handleRemovePDF}>{content}</Button>
                        )}
                        <Button onClick={handleShowHistory} bsStyle="primary">История</Button>
                        
                    </ButtonGroup>
                </ButtonToolbar>
            )
        }

        const programName = (cell, row) => {
            const {
                response,
                formId,
                valuesId,
                responseReportOne,
                responseReportTwo,
            } = row

            const api = createApiClient();
            const onClick = e => e.stopPropagation()

            const type = getTypeByResponseReport({ responseReportOne, responseReportTwo })

            const content = {
                undefined: 'Скачать PDF файл',
                one: 'Скачать PDF файл Отчёта №1',
                two: 'Скачать PDF файл Отчёта №2'
            }[type]

            return (<>
                <span title={cell}>{cell}</span>
                {response && (<>
                    <br />
                    <a
                        onClick={onClick}
                        href={api.getReportUrl({formId, valuesId, type})}
                        className="btn-link"
                    >
                        {content}
                    </a>
                </>)}
            </>)
        }

        const sortTime = (a, b, order, field) =>{
            if(order === 'desc') 
                return moment(a[field], "DD.MM.YYYY HH:mm:ss") - moment(b[field], "DD.MM.YYYY HH:mm:ss");  
            return moment(b[field], "DD.MM.YYYY HH:mm:ss") - moment(a[field], "DD.MM.YYYY HH:mm:ss");  
        }

        const wrap = {whiteSpace:"pre-line"};
        return (
            <div className="row" >
                <div className="col-sm-12">
                    <div className="header-table">
                        <h4 className="header-left">Текущие заявки</h4>
                    </div>
                    <BootstrapTable data={this.props.listUserForms}
                                    trClassName={this.rowAdditionalRequest}
                                    scrollTop={ 'Bottom' }
                                    options={options} hover
                                    bodyContainerClass="not-react-bs-container-body">
                      <TableHeaderColumn dataField='response' hidden></TableHeaderColumn>
                      <TableHeaderColumn dataField='formId' hidden></TableHeaderColumn>
                      <TableHeaderColumn dataField='valuesId' isKey={true} hidden></TableHeaderColumn>
                      <TableHeaderColumn dataField='error' width="130px" dataFormat={actionFormate}>#</TableHeaderColumn>
                      <TableHeaderColumn dataField='formName' width="250px" tdStyle={wrap} dataFormat={programName} dataSort>Программа</TableHeaderColumn>
                      <TableHeaderColumn dataField='typeForm' dataSort width="100px">Тип</TableHeaderColumn>
                      <TableHeaderColumn dataField='number'  dataSort width="130px" >Номер заявки</TableHeaderColumn>
                      <TableHeaderColumn dataField='createTime' dataSort width="150px" sortFunc={sortTime}>Дата создания </TableHeaderColumn>
                      <TableHeaderColumn dataField='changeTime' dataSort width="150px" sortFunc={sortTime}>Дата изменения </TableHeaderColumn>
                      <TableHeaderColumn dataField='company' width="150px" dataSort>Компания</TableHeaderColumn>
                      <TableHeaderColumn dataField='status' dataFormat={statusFormate} dataSort width="150px">Статус</TableHeaderColumn>
                      <TableHeaderColumn dataField='currentStep' width="150px" dataFormat={nextStep} dataSort>Текущий шаг</TableHeaderColumn>
                      <TableHeaderColumn dataField='updateState' dataFormat={formateUpdate} dataSort width="100px">Признак</TableHeaderColumn>
                    </BootstrapTable>
                    
                </div>
                <HistoryStatusModal ref={(modal) => this.modalHistory = modal }/>
                <NotifyModal ref={(modal) => this.modalNotify = modal } />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/program/RequestList.tsx